import React, { ReactHTMLElement } from 'react';

import './CouponCode.css'


interface CouponCodeProps {
  logo: any;
  amount: string;
  product: string;
  code: string;
}

export default function CouponCode(props: CouponCodeProps) {

  const [copied, setCopied] = React.useState(false);

  const inputRef = React.createRef<HTMLInputElement>();

  return (
    <div className="coupon-container">
      <div className="coupon-card">
        <div className="coupon-main">
          <div className="co-img">
            <img
              src={props.logo}
              style={{ objectFit: "contain" }}
              alt=""
            />
          </div>
          <div className="vertical"></div>
          <div className="coupon-content">
            <h2>{props.product}</h2>
            <h1>{props.amount} <span>Coupon</span></h1>
            <p>Valid till 31 December 2023</p>
          </div>
        </div>
        <div className="copy-button">
          <input ref={inputRef} type="text" readOnly value={props.code} />
          <button onClick={() => {
            inputRef.current?.select();
            document.execCommand("copy");
            setCopied(true);
          }} className="copybtn">{copied ? "COPIED" : "COPY"}</button>
        </div>
      </div>
    </div>
  )
};